import Aos from 'aos'

import { Cursor } from '@js/animations/Cursor'
import { Frame } from '@js/animations/Frame'
import { Grid } from '@js/animations/Grid'
import { Image } from '@js/animations/Image'
import { PageHeader } from '@js/animations/PageHeader'
import { TypeWriting } from '@js/animations/TypeWriting'
import { Video } from '@js/animations/Video'
import { Transition } from '@js/animations/Transition'
import { Separator } from '@js/animations/Separator'
import { Scroll } from '@js/animations/Scroll'

export class Animation {
  static registerAnimations () {

    const animations = [
      Cursor,
      Scroll,
      Frame,
      Grid,
      Image,
      PageHeader,
      TypeWriting,
      Video,
      Transition,
      Separator
    ]

    animations.forEach(animation => {
      const instance = new animation()
      if (instance.isCallable()) {
        instance.init()
      }
    })

    Aos.init({
        offset: 0,
        easing: 'ease-out-cubic',
        disable: 'mobile'
      }
    )

  }
}
